// extracted by mini-css-extract-plugin
module.exports = {"icon":"index-styles-module--icon--2iFIv"};